<template>
  <section class="post-recents">
    <div :class="!isMobile ? 'container' : 'row crsl-mobile'">
      <div class="block-header">
        <h2 v-text="translateMain.titleBlog"></h2>
        <p>
          {{ translateMain.subtitleBlog }}
        </p>
        <router-link :to="{
          name: 'BlogsPage',
          params: { locale }
        }" class="button button--o">
          {{ translateMain.goToBlog }}
          <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg" style="margin-left: 10px" />
        </router-link>
      </div>
      <BlockBlack :styles="BlackIsMobile()" />
      <div class="list__cards">
        <div class="model-list model-list--home">
          <swiper :slidesPerView="1.07" 
          :spaceBetween="10" 
          :pagination="{ dynamicBullets: true, clickable: true }"
          :breakpoints="{
              '769': {
                slidesPerView: 2,
                spaceBetween: 20
              },
              '1000': {
                slidesPerView: 3,
                spaceBetween: 20
              }
            }" :modules="modules" class="mySwiper" ref="swiperBlogs" style="
              --swiper-pagination-color: black;
              --swiper-pagination-bullet-inactive-color: black;
              --swiper-pagination-bullet-size: 12px;
              --swiper-pagination-bottom: 0px;
            ">
            <swiper-slide v-for="(post, index) in postBlogDesktop" :key="index" 
            >
              <PostListItem :posts="post" :homepage="true" />
            </swiper-slide>
          </swiper>
          <swiper 
          :slidesPerView="1.07" 
          :spaceBetween="10" 
          :pagination="{ dynamicBullets: true, clickable: true }"
          :breakpoints="{
              '769': {
                slidesPerView: 2,
                spaceBetween: 20
              },
              '1000': {
                slidesPerView: 3,
                spaceBetween: 20
              }
            }" :modules="modules" class="mySwiper swiper-mobile" ref="swiperBlogs" style="
              --swiper-pagination-color: black;
              --swiper-pagination-bullet-inactive-color: black;
              --swiper-pagination-bullet-size: 12px;
              --swiper-pagination-bottom: 0px;
            ">
            <swiper-slide v-for="(post, index) in postBlogMobile" :key="index" 
            >
              <PostListItem :posts="post" :homepage="true" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
// import PostSlideItem from './PostSlideItem.vue'
import BlockBlack from 'components/BlocksCustom/BlockBlack.vue'
import { isMobile } from 'views/shared/utils/mobile'
import PostListItem from './PostListItem.vue'
import PostListItemMobile from './PostListItemMobile.vue'
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import translateMain from 'tradutors/menu'
import api from "../../api"

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

// import required modules
import { Pagination } from 'swiper'

export default defineComponent({
  name: 'BlogBlock',
  components: { PostListItem, PostListItemMobile, BlockBlack, Swiper, SwiperSlide },
  setup() {
    return {
      modules: [Pagination]
    }
  },
  props: ['postBlogs', 'path2'],
  computed: {
    ...mapState(localeStore, ['locale']),
    translateMain: function () {
      if (this.locale === 'pt-br') {
        return translateMain.portugues
      } else {
        return translateMain.ingles
      }
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      postBlogDesktop: [],
      postBlogMobile: [],
    }
  },
  watch: {
    'postBlogs': function () {
      this.postDesktop()
      this.postMobile()
    }
  },
  methods: {
    BlackIsMobile() {
      return isMobile() ? { height: '140px' } : { height: '110px' }
    },
    postDesktop() {
      this.postBlogDesktop = this.postBlogs.slice(0, 3)
    },
    postMobile() {
      this.postBlogMobile = this.postBlogs.slice(3, 6)
    }
  }
})
</script>

<style scoped lang="css">
.button--o {
  color: #000000;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  text-align: right;
  background-color: white;
  padding-left: 47px;
  padding-right: 49px;
}

.button--o svg {
  color: #b20000;
}

.list-cards-mobile {
  display: none;
}

h2 {
  height: 77px;
  color: #FFFFFF;
  font-family: "Bebas-Neue-Light";
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.block-header p {
  color: #FFFFFF;
  font-family: 'Roboto-Medium';
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
}

.block-header {
  margin-bottom: 6px;
  justify-content: center;
  padding-top: 20px;
}

.list__cards {
  margin-top: -60px;
}

.model-list--home {
  position: absolute;
  width: 100%;
}

.swiper-mobile {
  display: block;
}

@media screen and (max-width: 1040px) {
  .block-header p {
    display: none;
  }
}

@media screen and (max-width: 769px) {
  .swiper-mobile {
    display: none;
  }
  .list__cards {
    margin-top: -82px;
  }

  .block-header {
    margin-bottom: 20px;
  }

  .block-header a {
    left: 50%;
    transform: translate(-50%, 0%);
  }

  .block-header h2 {
    margin-right: 0px;
  }

  .model-list--home {
    margin-top: -75px;
  }

  .button--o {
    display: none;
  }

  .list-cards-mobile {
    display: block;
    top: 200px;
  }

  h2 {
    height: 58px;
    color: #FFFFFF;
    font-family: "Bebas-Neue-Light";
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }

  .swiper-slide {
    width: 319px !important;
    margin-right: 12px !important;
  }

  .container {
    /* padding-right: 0px; */
    padding-left: 15px;
  }

  .crsl-mobile {
    margin-left: 3px;
    margin-right: 12px;
  }

}
</style>
